import { render, staticRenderFns } from "./searchDown.vue?vue&type=template&id=44f9799c&scoped=true&"
import script from "./searchDown.vue?vue&type=script&lang=js&"
export * from "./searchDown.vue?vue&type=script&lang=js&"
import style0 from "./searchDown.vue?vue&type=style&index=0&id=44f9799c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f9799c",
  null
  
)

export default component.exports